/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import can from 'can';
import 'components/dfp-advert-unit/dfp-advert-unit';

export const Article = BaseControl.extend({
    init: function() {
        this._super();

        if (this.options.ad) {
            this.insertAds();
        }
    },

    insertAds: function() {
        const paragraphs = $('.m-rich-text.is-drop-cap')
            .first()
            .find('p');
        const adIndex = Number(this.options.ad.paragraphNum) - 1;
        const index =
            paragraphs.length >= adIndex ? adIndex : paragraphs.length - 1;

        $(`<div class='c-google-ads' />`).insertAfter(paragraphs.eq(index));

        const view = can.stache(
            `
                <dfp-advert-unit
                    reload-interval='{{reloadInterval}}'
                    ad-unit-path='{{adUnitPath}}'
                    {sizes}='sizes'
                    {responsive}='responsive'
                />
            `,
        )({
            adUnitPath: this.options.ad.id,
            responsive: true,
            sizes: this.options.ad.sizes,
            reloadInterval: 5,
        });

        can.$(view).appendTo($('.c-google-ads'));
    },
});
